import React from "react";
import AppleIcon from "@mui/icons-material/Apple";
import { Box, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { SLIDING_PUZZLE_QUEST_APP_STORE_URL } from "../../config/nativeAppsVisibility";
import { usePagesTranslation } from "../locales";
import { storeBadgeChromeSx, storeBadgeLine1Sx, storeBadgeLine2Sx } from "./storeBadgeChrome";

/**
 * App Store link styled to match the Google Play store badge.
 */
export default function AppStoreBadgeLink({
    href = SLIDING_PUZZLE_QUEST_APP_STORE_URL,
    height = 40,
    sx = {},
    ariaLabel,
}) {
    const { t } = usePagesTranslation();
    const label =
        ariaLabel
        ?? t(
            "landing.app-store-badge-aria",
            "Download Sliding Puzzle Quest on the App Store (opens in a new tab)"
        );
    const line1 = t("landing.app-store-download-line1", "Download on the");
    const line2 = t("landing.app-store-download-line2", "App Store");

    return (
        <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            sx={{ ...storeBadgeChromeSx(height), ...sx }}
        >
            <AppleIcon sx={{ fontSize: height * 0.62, flexShrink: 0 }} aria-hidden />
            <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.05, minWidth: 0 }}>
                <Typography component="span" sx={storeBadgeLine1Sx(height)}>
                    {line1}
                </Typography>
                <Typography component="span" sx={storeBadgeLine2Sx(height)}>
                    {line2}
                </Typography>
            </Box>
        </Link>
    );
}

AppStoreBadgeLink.propTypes = {
    href: PropTypes.string,
    height: PropTypes.number,
    sx: PropTypes.object,
    ariaLabel: PropTypes.string,
};
